import { render, staticRenderFns } from "./CoronaInfo.vue?vue&type=template&id=6a71efa2&scoped=true&"
import script from "./CoronaInfo.vue?vue&type=script&lang=js&"
export * from "./CoronaInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a71efa2",
  null
  
)

export default component.exports